import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_55: DocMigration = {
  maxSchemaVersion: "0.0.55",
  description: "Interior material settings",
  apply(json: any) {
    const mtlSettingsId = json.settingsOverride?.interiorMaterials;

    if (!mtlSettingsId) {
      const newSettingsId = uid();

      json.settings[newSettingsId] = {
        type: "INTERIOR_MATERIAL_SETTINGS",
        palettes: ["INTERIOR_B01"],
      };

      if (!json.settingsOverride) {
        json.settingsOverride = {};
      }

      json.settingsOverride.interiorMaterials = newSettingsId;
    }

    return json;
  },
};

export default migration_0_0_55;
